import { FC } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import CountBoxImage from '../../../../assets/images/metro/CountBox.svg';

type Props = {
  className?: string;
  count: number;
};

const PeopleCount: FC<Props> = ({ count, className }) => {
  return (
    <div className={classNames(styles.peopleCount, className)}>
      <div className={styles.title}>В метро было:</div>
      <div className={styles.box}>
        <img src={CountBoxImage} className={styles.boxImage} alt="" />
        <div className={styles.boxText}>{count}</div>
      </div>
    </div>
  );
};

export default PeopleCount
